var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mobile-detail-acq-f-t-cta" } }, [
    _vm.offersHref == null && _vm.onlineHref == null && _vm.eresaHref == null
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 pt-2" },
            [
              _c("ob1-message-alerte", {
                attrs: {
                  "is-simple-alerte": false,
                  title: _vm.alertStatusDto.title,
                  text: _vm.alertStatusDto.message,
                  type: "warning",
                },
              }),
            ],
            1
          ),
        ])
      : _vm.offersHref
      ? _c(
          "div",
          [
            _c("mobileDetailsCtaAndAvailabilityMentions", {
              attrs: {
                "available-online": _vm.availableOnline,
                "estimated-delivery-label": _vm.estimatedDeliveryLabel,
                "available-eresa": _vm.availableEresa,
                "preorder-mention": _vm.preorderMention,
                label: _vm.buttonLabel,
                href: _vm.authenticationPopinLabels ? null : _vm.offersHref,
                "data-target": _vm.authenticationPopinLabels
                  ? "#authenticationPopIn"
                  : null,
              },
            }),
            _vm._v(" "),
            _vm.authenticationPopinLabels
              ? _c("authentication-popin", {
                  attrs: {
                    id: "authenticationPopIn",
                    title: _vm.authenticationPopinLabels.title,
                    subtitle: _vm.authenticationPopinLabels.subtitle,
                    "new-client-title":
                      _vm.authenticationPopinLabels.newClientTitle,
                    "new-client-description":
                      _vm.authenticationPopinLabels.newClientDescription,
                    "new-client-href": _vm.offersHref,
                    "client-title":
                      _vm.authenticationPopinLabels.alreadyClientTitle,
                    "client-description":
                      _vm.authenticationPopinLabels.alreadyClientDescription,
                    "client-href": _vm.offersClientHref,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm.onlineHref && _vm.eresaHref
      ? _c(
          "div",
          [
            _c("mobileDetailsCtaAndAvailabilityMentions", {
              attrs: {
                "available-online": _vm.availableOnline,
                "estimated-delivery-label": _vm.estimatedDeliveryLabel,
                "available-eresa": _vm.availableEresa,
                label: _vm.buttonLabel,
                "preorder-mention": _vm.preorderMention,
                "data-target": "#allDisponibilitiesPopIn",
              },
            }),
            _vm._v(" "),
            _c("all-disponibilities-popin", {
              attrs: {
                title: _vm.allDisponibilitiesPopin.title,
                "tdc-section": _vm.allDisponibilitiesPopin.tdcSection,
                "eresa-section": _vm.allDisponibilitiesPopin.eresaSection,
                "eco-foot-note": _vm.allDisponibilitiesPopin.ecoFootNote,
                "tdc-href": _vm.onlineHref,
                "eresa-href": _vm.eresaHref,
              },
            }),
          ],
          1
        )
      : _c(
          "div",
          [
            _c("mobileDetailsCtaAndAvailabilityMentions", {
              attrs: {
                "available-online": _vm.availableOnline,
                "estimated-delivery-label": _vm.estimatedDeliveryLabel,
                "available-eresa": _vm.availableEresa,
                "preorder-mention": _vm.preorderMention,
                label: _vm.buttonLabel,
                href: _vm.onlineHref ? _vm.onlineHref : _vm.eresaHref,
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }